export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100/50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-8 rounded-lg bg-accent-500/15 flex items-center justify-center flex-shrink-0">
            <i className="ri-information-line text-accent-400"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">关于我们</h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
              在线吃瓜是一个专注于吃瓜内容入口导航的品牌平台。我们致力于为全网用户提供
              <strong className="text-primary-400 font-semibold">91在线吃瓜网</strong>、
              <strong className="text-primary-400 font-semibold">线路一</strong>等官方及最新入口地址的实时更新与聚合服务。
            </p>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
              面对复杂的网络环境，在线吃瓜持续监测各线路可用状态，及时提供
              <strong className="text-accent-400 font-semibold">备用网址</strong>与
              <strong className="text-accent-400 font-semibold">官方线路</strong>信息。无论入口如何变化，
              用户只需记住「在线吃瓜」一个名字，即可通过本站获取所有有效的最新入口，真正做到访问不迷路。
            </p>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed">
              自上线以来，在线吃瓜已累计服务超过百万用户，日均更新入口检测信息超过百次，
              以稳定、快速、安全为核心理念，持续打造最值得信赖的吃瓜入口导航品牌。
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="p-5 rounded-xl bg-background-50 border border-background-300/30 text-center">
              <span className="text-2xl md:text-3xl font-heading font-bold text-primary-400">100万+</span>
              <p className="text-xs text-foreground-600 mt-1">累计服务用户</p>
            </div>
            <div className="p-5 rounded-xl bg-background-50 border border-background-300/30 text-center">
              <span className="text-2xl md:text-3xl font-heading font-bold text-accent-400">365天</span>
              <p className="text-xs text-foreground-600 mt-1">全年无间断更新</p>
            </div>
            <div className="p-5 rounded-xl bg-background-50 border border-background-300/30 text-center">
              <span className="text-2xl md:text-3xl font-heading font-bold text-secondary-400">99.9%</span>
              <p className="text-xs text-foreground-600 mt-1">入口可用率</p>
            </div>
            <div className="p-5 rounded-xl bg-background-50 border border-background-300/30 text-center">
              <span className="text-2xl md:text-3xl font-heading font-bold text-primary-400">5+</span>
              <p className="text-xs text-foreground-600 mt-1">备用线路保障</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}